import BaseComponent from 'foundation/base-component';
import { isValid } from 'date-fns';

class RolexWatchComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.intervalId = null;
        this.currentDate = new Date(this.options.currentDate);
        this.thresholdDate = new Date(this.options.thresholdDate);

        if (!isValid(this.currentDate)) {
            throw new Error('Please provide a valid "currentDate" parameter');
        }

        if (!isValid(this.thresholdDate)) {
            throw new Error('Please provide a valid "thresholdDate" parameter');
        }

        this.init();
    }

    init() {
        let isSimple = false;

        if (!this.options.shouldShowCountdown) {
            isSimple = true;
        } else {
            isSimple = this.currentDate > this.thresholdDate;
        }

        this.lazyloadIframes();

        if (isSimple) {
            this.element.classList.add('is-simple');
        } else {
            this.element.classList.add('is-countdown');
            this.intervalId = setInterval(() => {
                this.currentDate.setSeconds(this.currentDate.getSeconds() + 1);

                const shouldSimple = this.currentDate > this.thresholdDate;

                if (shouldSimple !== isSimple) {
                    clearInterval(this.intervalId);
                    this.element.classList.remove('is-countdown');
                    this.element.classList.add('is-simple');
                }
            }, 1000);
        }

    }

    lazyloadIframes() {
        if (!Array.isArray(this.refs.iframes)) return;

        this.refs.iframes.forEach((iframe) => {
            iframe.src = this.getAttribute(iframe, 'src');
        });
    }
}

export default RolexWatchComponent;
